import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate, getStyles, createArray, priceFormat, localizePrice } from '../../../../shared/utility';

import Tag from '../../Tag/Tag';
import TextClamp from '../../TextClamp/TextClamp';
import Icon from '../../Icon/Icon';
import Button from '../../Button/Button';
import Bar from '../../Loading/Bar/Bar';

import localStyles from './CardContent.scss';
const styles = getStyles(localStyles);

const cardContent = (props) => {
    /* * * * * * * * * *
     * ITEM TYPE TAGS  *
     * * * * * * * * * */
    const itemTypesArray = props.loading ? [] : createArray(props.itemTypeData)
        .map((item, index) => item.config.id === props.item.itemTypeReference.id ?
            <Tag
                key={index}
                classes={styles('footer__tag')}
                modifiers={['small']}
                color={item.config.color}>
                {item.config.name}
            </Tag> : null
        );
    const tags = (
        <div className={styles('tags', `tags--${props.viewMode}`, 'line-height--collapsed')}>
            {props.loading ? <Bar classes={styles('tags__loader', 'small')} modifiers={['darker', 'no-animation']} /> : itemTypesArray}
        </div>
    );

    /* * * * * * * * * *
     * ITEM PROPERTIES *
     * * * * * * * * * */
    const itemPropsArray = props.loading ? [] : createArray(props.item.itemProperties).slice(0, 3).map((item, index) => (
        <abbr key={index} className={styles('footer__prop', 'align--center')} title={item.config.name}>
            <img src={item.config.imageReference.source} alt="" className={styles('footer__prop__icon')} />
            <span className={styles('footer__prop__name', `footer__prop__name--${props.viewMode}`, 'c--text-light', 'tiny')}>
                <TextClamp lines={2} forceHeight={true}>
                    {item.config.name}
                </TextClamp>
            </span>
        </abbr>
    ));
    const properties = props.viewMode !== 'card' ? (
        <div className={styles('footer__props', `footer__props--${props.viewMode}`)}>
            {itemPropsArray}
        </div>
    ) : null;

    /* * * * * * *
     * LOCATION  *
     * * * * * * */
    const location = props.loading ? <Bar classes={styles('header__title__location__loader')} modifiers={['no-animation']} /> : !!props.item.locationReference.address ?
        `${props.item.locationReference.address.street} ${props.item.locationReference.address.number || ''}${props.item.locationReference.numberAddition || ''}, ${props.item.locationReference.address.city}` : null;
    const locationMarker = !!location && !props.loading ? <Icon icon={'location'} modifiers={['inline']} /> : null;

    /* * * * *
     * PRICE *
     * * * * */
    const priceValue = !props.loading && !!props.item.displayPrice ? priceFormat(props.item.displayPrice) : null;
    const price = props.loading ? <Bar modifiers={['darker', 'no-animation']} /> : !!props.item.displayPrice ? localizePrice(priceValue, props.item.displayPrice.currencyCode, props.locale) : null;
    const priceUnit = !!priceValue ? 'Per ' + props.item.displayPrice.unit : null;
    const taxUnit = !!priceValue ? translate(!props.isAuthorized || (!!props.userData && !!props.userData.preferences && props.userData.preferences.showPricesIncludingVat && props.userData.preferences.preferredPaymentAccountId === 0) ? 'pricing.VATIncludedShort' : 'pricing.VATExcludedShort', props.language) : null;

    /* * * * * *
     * RETURN  *
     * * * * * */
    return (
        <Fragment>
            {props.viewMode === 'card' ? tags : null}
            <div className={styles('header', `header--${props.viewMode}`, 'flex', 'flex--justify-between', 'flex--align-start')}>
                <div className={styles('header__title')}>
                    {props.loading ? (
                        <h5 className={styles('header__title__title', `header__title__title--${props.viewMode}`)}>
                            <Bar modifiers={['darker']} classes={styles('header__title__title__loader')} />
                        </h5>
                    ) : (
                        <TextClamp
                            lines={2}
                            classes={styles('header__title__title', `header__title__title--${props.viewMode}`)}
                            tagName={'h5'}
                            forceHeight={props.viewMode === 'map'}
                        >
                            {props.item.name}
                        </TextClamp>
                    )}
                    <p className={styles('header__title__location', 'c--text-light')}>
                        <small>{locationMarker}{location}</small>
                    </p>
                    {props.viewMode === 'list' ? tags : null}
                </div>
                {props.viewMode === 'map' ? null : (
                    <div className={styles('header__price', 'align--right')}>
                        <h5 className={styles('header__price__fee')}>
                            {price}
                            {!!priceUnit ? <span className={styles('header__price__unit', 'tiny', 'c--text-lighter')}>{priceUnit}</span> : null}
                            {!!taxUnit ? <span className={styles('header__price__unit', 'tiny', 'c--text-light')}> {taxUnit}</span> : null}
                        </h5>
                    </div>
                )}
            </div>
            <div className={styles('footer')}>
                {!!properties ? properties : null}
            </div>
            {props.viewMode === 'map' ? (
                <Button
                    href={`/item/${props.item.id}`}
                    modifiers={['primary', 'stretch', 'm', 'spaced']}
                >{translate('pricing.bookNow', props.language)}</Button>
            ) : null}
        </Fragment>
    );
};

cardContent.propTypes = {
    // properties
    item: PropTypes.object,
    loading: PropTypes.bool,
    viewMode: PropTypes.string.isRequired,
    itemTypeData: PropTypes.arrayOf(PropTypes.object),
    isAuthorized: PropTypes.bool.isRequired,
    userData: PropTypes.shape({
        preferences: PropTypes.object
    }),

    language: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    return {
        isAuthorized: !!state.details.user.data,
        userData: state.details.user.data,
        itemTypeData: state.list.itemTypes.data,

        language: state.global.localization.language,
        locale: state.global.localization.locale
    };
};

export default connect(mapStateToProps, null)(cardContent);



// WEBPACK FOOTER //
// ./src/components/UI/Card/CardContent/CardContent.js